/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateManualBankLinkingRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateManualBankLinking.pb'
import {CreateManualBankLinkingResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateManualBankLinking.pb'


export const createManualBankLinking = (request:CreateManualBankLinkingRequest, options?: CashRequestOptions) => post<CreateManualBankLinkingRequest, CreateManualBankLinkingResponse>("/2.0/cash/create-manual-bank-linking", request, {...options, rejectOnError: true })